import React, { useEffect, useState } from 'react'
import CourseHeader from '../components/CourseHeader'
import { specificCourseInfo } from '../assets/specificCourseInfo'
import SpecificCourseCard from '../components/SpecificCourseCard'
import "./Styles.css"
import { useParams } from 'react-router-dom'
import CourseContent from '../components/CourseContent'
import { Button } from 'reactstrap'
import coming from "../assets/coming.png"

const SpecificCourse = () => {
    const { name } = useParams()
    const [courseInfo, setCourseInfo] = useState(null)

    useEffect(() => {
        const course = specificCourseInfo.filter(item => item.name.toLowerCase() === name.toLowerCase())
        setCourseInfo(course[0])
    }, [name])

    return (
        <div className='courses-main-wrapper'>
            <CourseHeader />
            <div className='specific-course-info'>
                <h3>{courseInfo !== null && courseInfo.name}💻🌐</h3>
                <div className='specific-course-info-0'>
                    <ul className='specific-course-keypoints'>
                        {courseInfo !== null && courseInfo.keypoints.map(point => {
                            return (
                                <li style={{ marginBottom: "20px", fontSize: "18px" }}>⭐{point}</li>
                            )
                        })}
                    </ul>
                    <div className='specific-course-enroll'>
                        <img src={coming} alt="img" />
                        <h5 style={{ margin: "20px 0" }}>Validity: 900 days</h5>
                        <Button disabled={true} className='specific-course-enroll-btn' color="success">ENROLL NOW</Button>
                        <h5 style={{ marginTop: "20px" }}>Fees: <s>5500/-</s> 2500/-</h5>
                    </div>
                </div>
            </div>
            <div className='specific-course-who'>
                <h3 className='specific-course-head'>Who this course is for</h3>
                <div className='specific-course-who-cards'>
                    {courseInfo !== null && courseInfo.who.map(item => {
                        return (
                            <SpecificCourseCard key={item.id} head={item.head} desc={item.desc} />
                        )
                    }
                    )}
                </div>
            </div>
            <div className='specific-course-who'>
                <h3 className='specific-course-head'>Course Content</h3>
                <div className='specific-course-content'>
                    <div className='specific-course-content-1'>
                        {courseInfo !== null && courseInfo.content.map(item => {
                            return (
                                <CourseContent seasonId={item.seasonId} season={item.season} name={item.name} episodes={item.episodes} />
                            )
                        })}
                    </div>
                    <div className='specific-course-content-2'></div>
                </div>
            </div>
        </div >
    )
}

export default SpecificCourse
